import { React, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Box, Skeleton, Typography } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import moment from 'moment';
import priceFormatter from '../../../../util/priceFormatter';
import useStyles from './style';

/**
 * @name PrepayCartItem - PrepayCartItem
 * @param {string} title - Title of each cart item
 * @returns {JSX.Element} - Prepay cart item
 */
const PrepayCartItem = ({
  title,
  contractLength,
  variant,
  price,
  itemType,
  loading,
  discountedPrice,
  portInPhoneNumber,
  portingDate,
  offerId,
  addOnId,
  getClickedItem,
  afterPrice,
  openConfirmationModal,
  deleteIcon,
  handsetId,
  showPortingInfo,
  setShowPortingInfo,
  AddonDiscount,
}) => {
  const theme = useTheme();
  const style = useStyles(theme);
  const formatedPortingDate = moment(portingDate).format('DD/MM/YYYY');

  const confirmDelete = e => {
    getClickedItem(
      e.currentTarget.getAttribute('value'),
      e.currentTarget.id,
      addOnId,
      itemType,
      handsetId
    );
    openConfirmationModal.enable();
  };

  useEffect(() => {
    if (portingDate && typeof setShowPortingInfo === 'function') {
      setShowPortingInfo(true);
    }
  }, [portingDate]);

  return !loading ? (
    <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
      <Box sx={style.itemBox} id={offerId}>
        <Box>
          <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
            <Stack direction='row'>
              <Typography
                component='p'
                variant='body1'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {title}
              </Typography>
            </Stack>

            <Stack direction='row' justifyContent='space-between' alignItems='baseline' spacing={2}>
              <Typography component='p' sx={{ color: theme.palette.primary.textColor3 }}>
                {itemType === 'HANDSET' && AddonDiscount !== undefined
                  ? priceFormatter(parseFloat(price - AddonDiscount))
                  : priceFormatter(parseFloat(price))}
              </Typography>
            </Stack>
          </Stack>
        </Box>

        <Stack
          direction='row'
          justifyContent='space-between'
          spacing={2}
          sx={style.afterPriceContainer}
        >
          <Typography variant='body2' sx={style.contactNumber}>
            {variant}
            {!contractLength?.includes('null') && contractLength}
            {discountedPrice > price && afterPrice}
          </Typography>
        </Stack>

        {showPortingInfo === true && showPortingInfo !== undefined && (
          <Box>
            <Stack direction='row' justifyContent='space-between' spacing={2}>
              <Typography variant='body2' sx={style.contactNumber}>
                Porting: &nbsp;
                <Typography variant='body2' sx={style.contactNumberBold}>
                  {portInPhoneNumber}
                  &nbsp;
                </Typography>
                onnn &nbsp;
                <Typography variant='body2' sx={style.contactNumberBold}>
                  {formatedPortingDate}
                </Typography>
              </Typography>
            </Stack>
          </Box>
        )}
      </Box>
      <Box sx={style.deleteIcon}>
        {deleteIcon && (
          <DeleteForeverIcon
            id={offerId}
            value={title}
            onClick={confirmDelete}
            fontSize='inherit'
            sx={{
              cursor: 'pointer',
              color: theme.palette.primary.offerPromo,
              '&:hover': { color: theme.palette.secondary.asterisk },
            }}
          />
        )}
      </Box>
    </Stack>
  ) : (
    <Skeleton variant='rectangular' width='100%' height='100%' />
  );
};

PrepayCartItem.displayName = 'PrepayCartItem';
export default PrepayCartItem;
